import React from 'react';
// material
import { makeStyles } from '@material-ui/core/styles';
import { Grid } from '@material-ui/core';
// components
import IconSquare from './IconSquare';

const industriesData = [
  {
    icon: process.env.PUBLIC_URL + '/home_page/industries/icon_realestate.svg',
    text: 'Real estate'
  },
  {
    icon: process.env.PUBLIC_URL + '/home_page/industries/icon_mortgage.svg',
    text: 'Mortgage'
  },
  {
    icon: process.env.PUBLIC_URL + '/home_page/industries/icon_solar.svg',
    text: 'Solar'
  },
  {
    icon: process.env.PUBLIC_URL + '/home_page/industries/icon_education.svg',
    text: 'Education/Admissions'
  },
  {
    icon: process.env.PUBLIC_URL + '/home_page/industries/icon_recruiting.svg',
    text: 'Recruiting'
  },
  {
    icon: process.env.PUBLIC_URL + '/home_page/industries/icon_insurance.svg',
    text: 'Insurance'
  },
  {
    icon: process.env.PUBLIC_URL + '/home_page/industries/icon_studentloans.svg',
    text: 'Student Loans'
  },
  {
    icon: process.env.PUBLIC_URL + '/home_page/industries/icon_seniors.svg',
    text: 'Seniors'
  },
  {
    icon: process.env.PUBLIC_URL + '/home_page/industries/icon_homeimprovement.svg',
    text: 'Home Improvement'
  },
  {
    icon: process.env.PUBLIC_URL + '/home_page/industries/icon_travel.svg',
    text: 'Travel & Leisure'
  },
  {
    icon: process.env.PUBLIC_URL + '/home_page/industries/icon_reatail.svg',
    text: 'Retail'
  },
  {
    icon: process.env.PUBLIC_URL + '/home_page/industries/icon_more.svg',
    text: 'And so much  more!'
  }
];

const Industries: React.FC<{}> = (props) => {

  const classes = useStyles({});

  return (
    <div className={classes.container}>
      
      <div className={classes.heading}>
        <div className={classes.servedContainer}>
          Industries Served
        </div>
      </div>
      <div className={classes.industryDiv}>
      <Grid container className={classes.industryBox}>
        {industriesData.map((industry: any, index: number) =>
          <Grid className={classes.tile} item xs={12} md={3} sm={6} key={`grid-${index}`}>
            <IconSquare icon={industry.icon} text={industry.text} />
          </Grid>
        )}
      </Grid>
      </div>
    </div>
    );
}
export default Industries;

const useStyles = makeStyles(theme => ({
  container:{
    padding:'40px 10% 80px',
    backgroundColor: '#FFF',
    [theme.breakpoints.down('sm')]: {
      padding:'20px 0 40px',
    },
  },
  industryDiv:{
   display:"flex",
   justifyContent:"center",
   alignItems:"center"
  },
  industryBox:{
   maxWidth:900
  },
  servedContainer:{
   maxWidth:1100
  },

  subContainer:{
    margin:10,
    backgroundColor:"white"
  },
  tile: {
    display:"flex",
    alignItems:"center",
    justifyContent:"center",
    flexDirection:"column",
    backgroundColor: 'white',
    height:150,

  },
  heading:{
    color: '#5A728F',
    fontFamily: 'Asap',
    fontSize: '34px',
    letterSpacing: 0,
    lineHeight: '39px',
    textAlign: 'center',
    padding: "0 0 20px",
    display: "flex",
    justifyContent: "center",
    alignItems: "center"
  }
  
}));


// WEBPACK FOOTER //
// ./src/pages/home/components/Industries.tsx